import { z } from 'zod/v3';
import { makeFieldSchemaFromZod } from '../utils';
import { InputGroupCheckboxCardUiOptionsSchema } from '../InputGroupCheckboxCard/schema';

export type InputGroupCheckboxCardFieldsFirstUiOptions = z.infer<
  typeof InputGroupCheckboxCardUiOptionsSchema
>;

export const InputGroupCheckboxCardFieldsFirstSchema = makeFieldSchemaFromZod(
  z.object({}).describe('Input Group Checkbox Card Fields First'),
  InputGroupCheckboxCardUiOptionsSchema,
);

export type InputGroupCheckboxCardFieldsFirstProps =
  typeof InputGroupCheckboxCardFieldsFirstSchema.type;

export const InputGroupCheckboxCardFieldsFirstSchemaFinal =
  InputGroupCheckboxCardFieldsFirstSchema.schema;
